import { definePartner } from "../definePartner";

/**
 * Xeno: an external CRM partner (legacy class 1), the most divergent: every
 * `isExternalProviderC1(...)` site in the old component was about it alone.
 *
 * Its coupon conversation reuses the LOYALTY redemption endpoint, so the whole envelope is
 * loyalty-shaped: the request body nests under `loyaltyInput`, success is `redemptionInfo.success`
 * rather than a `message`, and a `referenceId` arrives on the APPLY leg which every later call
 * (verify, and the release on removal) has to quote.
 *
 * ⚠️ `stampsExternalAuthentication: false` is a real difference: its OTP verifies the OFFER, not
 * the customer, so copying `authenticated` into `extAuthenticated` would satisfy a customer gate
 * nobody passed.
 *
 * ⚠️ The backend applies a Xeno offer only for a customer Xeno has verified (`applyOtp: required`;
 * partners.md §1); the app's verify through the loyalty redeem is what satisfies it.
 */
export default definePartner("xeno", {
  name: "Xeno",
  backend: {
    listsOffers: true,
    appliesOffers: true,
    applyOtp: "required",
    takesTypedCodes: true,
    releaseNeeds: ["customerPhone", "couponCode", "referenceId"],
    exercisedAtSave: true,
  },

  isExternalLoyalty: true,
  requiresCouponUnblock: true,
  unblockRequiresReferenceAndPhone: true,

  hasCouponModal: true,

  requiresOtpOnApply: true,
  honoursOfferOtpFlag: true,
  returnsItemLevelDiscounts: true,
  rollsBackUnappliedCoupon: true,
  sendsRequestId: true,

  verifyChannel: "loyalty-redeem",
  wrapsVerifyInLoyaltyInput: true,
  verifySuccessSignal: "redemption-info",
  stampsExternalAuthentication: false,
  referenceIdSource: "apply",
  // The backend defines `refundLoyaltyPoints` for it (points-conversations.md §2).
  refundsPoints: true,
});
